import { Component, OnInit, ViewChild } from '@angular/core';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { PrimkeService } from './primke.service';
import { PdfZaPrimkeService } from 'src/app/pdf-ovi/pdfZaPrimke.service';
import { PdfZaIzdatniceLotSirovinaPojedinacnoService } from 'src/app/pdf-ovi/pdfZaIzdatniceLotSirovinaPojedinacno.service';
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-primke',
  templateUrl: './primke.component.html',
  styleUrls: ['./primke.component.scss'],
  providers: [PrimkeService]
})
export class PrimkeComponent implements OnInit {
  @ViewChild('datumOdRef', { static: false }) datumOdRef: any;
  @ViewChild('datumDoRef', { static: false }) datumDoRef: any;
  @ViewChild('pretraziRef', { static: false }) pretraziRef: any;

  idkorisnik: any;
  access_token: any;
  idfirma: any;
  datumOd: any = moment();
  datumDo: any = moment();
  datumOd_za_slanje = moment().format('YYYY-MM-DD');
  datumDo_za_slanje = moment().format('YYYY-MM-DD');
  poruka: string;
  disableGumb: boolean = false;
  primke: any = [];
  stavke: any = [];
  naslov: string;
  dodaj_urediPrimkuPopupVisible = false;
  prikazi_gumb_uredi = false;
  prikazi_gumb_dodaj = false;
  dodajStavkuPopup = false;
  btn_uredi_stavka = 1;
  datum = moment();
  skladista: any = [];
  sviArtikli: any = [];
  odabranoSkladiste: any;
  odabranoSkladiste_id: any;
  odabranoZaglavlje_id: any;
  odabranoZaglavlje_status: any;
  sviPartneri: any = [];
  odabraniPartner: any;
  odabraniPartner_id: any;
  svePoslovnicePartnera: any = [];
  poslovnicePartneraFilter: any = [];
  odabranaPoslovnicaPartnera: any;
  odabranaPoslovnicaPartnera_id: any;
  brojOtpremnice: any;
  napomena: any;
  isLoading: boolean = true;
  pzId: any;
  psId: any;
  dozvoliClick = false;
  dozvoliUredivanje = false;
  podaci_stavka: any = [];
  nabavnaCijena: any;
  idArtikl: any;
  odabranArtikl: any;
  window: any;
  kolicinaPopup: any;
  cijenaPopup: any;
  rabatPopup: any;
  rabat_iznosPopup: any;
  brutoPopup: any;
  netoVrijednost: any;
  netoCijena: any;
  urediZavrsenePrimke: boolean = false; 

  povezaniDokumentiPopup = false;
  povezani_dokumenti: any = [];

  loadingVisible = false;

  private isProcessing = false;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: PrimkeService,
    private pdfzaprimkeService: PdfZaPrimkeService,
    private pdfZaIzdatniceLotSirovinaPojedinacnoService: PdfZaIzdatniceLotSirovinaPojedinacnoService,
  ) {

    this.onShowing = this.onShowing.bind(this);

    this.onChangeKolicina = this.onChangeKolicina.bind(this);
    this.cijenaIzmijenjena = this.cijenaIzmijenjena.bind(this);
    this.onChangeNV = this.onChangeNV.bind(this);
    this.onChangeBV = this.onChangeBV.bind(this);
    this.onValuChangedNC=this.onValuChangedNC.bind(this);
    this.onValuChangedRabat = this.onValuChangedRabat.bind(this);

    this.idkorisnik = localStorage.getItem('idsecuser');
    this.access_token = sessionStorage.getItem('token');
    this.idfirma = localStorage.getItem('firma');

    this.dohvatiPrimke();
    this.dohvatiSkladista();
    this.dohvatiPartnere();
    this.dohvatiSvePoslovnicePartnera();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().primke;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onToolbarPreparingStavke(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        visible: this.dozvoliUredivanje,
        options: {
        icon: 'plus',
        onClick: this.stavkaPopup.bind(this)
       }
     },
    )
  }

  onCellPrepared(e) {
    //console.log(e);
    if (e.rowType == "data") {
      if (e.column.dataField === "pz_status"){
        if (e.value == 'I') {
          e.cellElement.classList.add('circleYellow');
        }
        if (e.value == 'S') {
          e.cellElement.classList.add('circleRed');
        }
        if (e.value == 'Z') {
          e.cellElement.classList.add('circleGreen');
        }
      }
    }
  }

  calculateSortValue(rowData: any) {
    // If your receipt numbers are in format like "PZ-2024-001"
    const receiptNumber = rowData.pz_broj;
    
    // Remove any non-numeric characters and convert to number
    // This will sort based on the numeric value
    return parseInt(receiptNumber.replace(/\D/g, ''));
    
    // OR if you want to sort by the full string but in a specific way:
    // return receiptNumber.padStart(10, '0');
  }

  onShowing(e: any){
    e.component.option("title", this.naslov);
  }

  onInitNewRow(e: any){
    //console.log(e);
    this.naslov = 'Dodaj stavku';
    this.podaci_stavka = [];
  }

  onEditingStart(e) {
    //console.log(e);
    this.naslov = 'Uredi stavku';
    this.btn_uredi_stavka = 1;
    this.idArtikl = e.data.ar_id;
    this.podaci_stavka.ar_id = e.data.ar_id;
    this.nabavnaCijena = e.data;
    this.brutoPopup = e.data.ps_bruto_vrijednost;
  }

  dodajPrimkuPopup() {
    this.naslov = 'Dodaj primku';
    this.dodaj_urediPrimkuPopupVisible = true;
    this.prikazi_gumb_dodaj = true;
    this.prikazi_gumb_uredi = false;
    this.datum = moment();
    this.odabranoSkladiste = undefined;
    this.odabranoSkladiste_id = null;
    this.odabraniPartner = undefined;
    this.odabranaPoslovnicaPartnera = undefined;
    this.brojOtpremnice = undefined;
    this.napomena = undefined;
  }

  urediPrimkuPopup(e){
    //console.log(e.data);
    this.naslov = 'Uredi primku';
    this.dodaj_urediPrimkuPopupVisible = true;
    this.prikazi_gumb_dodaj = false;
    this.prikazi_gumb_uredi = true;
    this.pzId = e.data.pz_id;
    this.datum = e.data.pz_datum;
    this.odabranoSkladiste = e.data.poslovnica_po_id;
    this.odabraniPartner = e.data.partner_pa_id;
    this.filtirajPoslovnicePartnera(e).then((resFilter: any) =>{
      //console.log('res resFilter: ', resFilter);
      if (resFilter) {
        this.odabranaPoslovnicaPartnera = e.data.poslovnicapartnera_pp_id;
        //console.log('odabranaPoslovnicaPartnera: ', e.data.poslovnicapartnera_pp_id);
      }
    });
    this.brojOtpremnice = e.data.pz_dokumpar;
    this.napomena = e.data.pz_napomena;
  }

  filtirajPoslovnicePartnera(e){
    return new Promise((resolve) => {
      let ppFilter = [];
      ppFilter = this.svePoslovnicePartnera.filter(function(a) {return a.partner_pa_id == e.data.partner_pa_id})
      //console.log(ppFilter);
      this.poslovnicePartneraFilter = ppFilter;
      //console.log(this.poslovnicePartneraFilter);
      //this.dodaj_urediPrimkuPopupVisible = true;
      resolve(1)
    })
  }

  popupHidden(){
    
  }

  popupHiddenStavke(){
    this.podaci_stavka = [];
  }

  stavkaPopup(e){
    this.naslov = 'Dodaj stavku';
    this.podaci_stavka = [];
    this.dodajStavkuPopup = true;
    this.btn_uredi_stavka = 0;
    this.odabranArtikl = '';
    this.nabavnaCijena = null;
    this.brutoPopup = null;
    this.rabatPopup = null;
    this.netoVrijednost = null;
    this.netoCijena = null;
  }

  dohvatiSkladista() {
    this.skladista = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      firma_id: this.idfirma,
      access_token: this.access_token
    }
    this.service.dohvatiSkladistaV2(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        this.skladista = res.data
      } else {
        
      }
    });
  }

  dohvatiPartnere() {
    this.sviPartneri = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token
    }
    this.service.dohvatiPartnere(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        this.sviPartneri = new DataSource({
          store: res.data
        });
      } else {
        
      }
    });
  }

  dohvatiSvePoslovnicePartnera() {
    this.svePoslovnicePartnera = [];
    this.service.dohvatiSvePoslovnicepartnera({idpartner: null}).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        //zbog sporog dohvacanja poslovnica partnera dodano da priceka kad dohvati pa tek onda da moze dodavanje/uredivanje
        this.dozvoliClick = true;
        this.svePoslovnicePartnera = res.data
      } else {
        
      }
    });
  }

  odaberiSkladiste(e){
    //console.log(e);
    if(e.value){
      this.odabranoSkladiste_id = e.value;
    }else{

    }
  }

  odaberiPartnera(e){
    //console.log(e);
    if(e.value){
      this.odabraniPartner_id = e.value;
      if (e.event != undefined) {
        this.odabranaPoslovnicaPartnera = undefined;
        this.odabranaPoslovnicaPartnera_id = null;
      }
      let ppFilter = [];
      ppFilter = this.svePoslovnicePartnera.filter(function(a) {return a.partner_pa_id == e.value;})
      //console.log(ppFilter);
      this.poslovnicePartneraFilter = ppFilter;
      //console.log(this.poslovnicePartneraFilter);
    }else{
      this.odabraniPartner = undefined;
      this.odabraniPartner_id = null;
      this.odabranaPoslovnicaPartnera = undefined;
      this.odabranaPoslovnicaPartnera_id = null;
    }
  }

  odaberiPoslovnicuPartnera(e){
    //console.log(e);
    if(e.value){
      this.odabranaPoslovnicaPartnera_id = e.value;
    }else{
      this.odabranaPoslovnicaPartnera = undefined;
      this.odabranaPoslovnicaPartnera_id = null;
    }
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    this.isLoading = true;

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.dozvoliUredivanje = false;

      this.odabranoSkladiste_id = e.selectedRowsData[0].poslovnica_po_id;
      this.odabranoZaglavlje_id = e.selectedRowsData[0].pz_id;
      this.odabranoZaglavlje_status = e.selectedRowsData[0].pz_status;

      this.dohvatiStavke();
      if(e.selectedRowsData[0].pz_status == 'I'){
        this.dohvatiSveArtikle().then((sviArt: any) =>{
          //console.log('res sviArt: ', sviArt);
          if (sviArt) {
            this.isLoading = false;
            if(e.selectedRowsData[0].pz_status == 'Z' || e.selectedRowsData[0].pz_status == 'S'){
              this.dozvoliUredivanje = false;
            }else{
              this.dozvoliUredivanje = true;
            }
          }
        });
      }else{
        this.isLoading = false;
      }
    }
  }

  dohvatiStavke(){
    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.odabranoZaglavlje_id,
    };
    /* kod zavrsenih ili storniranih dohvaca iz jedne tablice a kod onih u izradi iz druge zato su razliciti api-i */
    if (this.odabranoZaglavlje_status == 'Z' || this.odabranoZaglavlje_status == 'S') {
      this.service.primkaStavkePopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.stavke = res.data;
      }
    });
    }else{
      this.service.tmpprometstavkePopis(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
      });
    }
  }

  dohvatiSveArtikle(){
    return new Promise((resolve) => {
      this.sviArtikli = [];
      let podaciZaSlanje = {
        idkorisnik: this.idkorisnik,
        idfirma: this.idfirma,
        access_token: this.access_token,
        po_id: this.odabranoSkladiste_id
      };
      //console.log(podaciZaSlanje);
      this.service.primkaSviArtikli(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.sviArtikli = res.data;
          resolve(1);
        }
      });
    });
  }

  odaberiArtikl(e){
    //console.log(e);
    this.idArtikl = e.itemData.ar_id;
    this.podaci_stavka = [];
    this.podaci_stavka.za_nabcij = e.itemData.za_nabcij;
    this.podaci_stavka.za_stanje = e.itemData.za_stanje;
    this.kolicinaPopup = 1;
    this.podaci_stavka.jedinicamjere_JM_SIFRA = e.itemData.jedinicamjere_JM_SIFRA;
    this.podaci_stavka.ps_nabcij =  e.itemData.za_nabcij; //0;
    this.cijenaPopup = e.itemData.za_nabcij; //0;;
    this.brutoPopup = this.kolicinaPopup * this.cijenaPopup; //0;
    this.podaci_stavka.pz_posto = e.itemData.posto;
    //this.podaci_stavka.ps_bruto_vrijednost = 0;
    //this.podaci_stavka.ps_postorabata = 0;
    this.rabatPopup = 0;
    //this.podaci_stavka.ps_rabat = 0;
    //this.podaci_stavka.neto_cijena = 0;
    this.netoCijena = 0;
    //this.podaci_stavka.neto_vrijednost = 0;
    this.netoVrijednost = 0;
  }

  editStavka(e){
    //console.log('editStavka: ', e);
    if(e.dataField === "ps_ulaz"){
      this.kolicinaPopup = e.value;
      //console.log('kolicinaPopup: ', this.kolicinaPopup);
    }
    if(e.dataField === "ps_nabcij"){
      this.cijenaPopup = e.value;
      //console.log('cijenaPopup: ', this.cijenaPopup);
    }
    if(e.dataField === "ps_postorabata"){
      this.rabatPopup = e.value;
      //console.log('rabatPopup: ', this.rabatPopup);
    }
    if(e.dataField === "neto_cijena"){
      this.netoCijena = e.value;
      //console.log('netoCijena: ', this.netoCijena);
    }
    if(e.dataField === "neto_vrijednost"){
      this.netoVrijednost = e.value;
      //console.log('netoVrijednost: ', this.netoVrijednost);
    }
    //console.log('*****kolicinaPopup*****', this.kolicinaPopup)
    //console.log('*****kolicinaPopup_typeof***** ', typeof(this.kolicinaPopup));
    //console.log('*****cijenaPopup*****', this.cijenaPopup)
    //console.log('*****cijenaPopup_typeof*****', typeof(this.cijenaPopup));
    //console.log('*****netoCijena*****', this.netoCijena)
    //console.log('*****netoCijena_typeof*****', typeof(this.netoCijena));

    this.brutoPopup = +(this.kolicinaPopup*+this.cijenaPopup).toFixed(2) || 0;
    this.netoVrijednost = +(+this.netoCijena*+this.kolicinaPopup).toFixed(3) || 0;
    let rabatNetoC = +(this.cijenaPopup*(+this.rabatPopup/100)) || 0;
    this.netoCijena = +(+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
    //this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;

    //console.log('----->brutoPopup', this.brutoPopup);
    //console.log('----->netoCijena: ', this.netoCijena);
    //console.log('----->netoVrijednost', this.netoVrijednost);
    //console.log('----->rabat_iznosPopup: ', this.rabat_iznosPopup);
  }

  onChangeKolicina(e){
    //console.log(e);
    if(e.value && e.event != undefined){
      //console.log('onChangeKolicina: ', e);
      this.kolicinaPopup = e.value;
      this.brutoPopup = +(this.kolicinaPopup*+this.cijenaPopup).toFixed(2) || 0;
      let rabatNetoC = +(this.cijenaPopup*(+this.rabatPopup/100)) || 0;
      this.netoCijena = +(+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
      this.netoVrijednost = +(this.netoCijena*+this.kolicinaPopup).toFixed(3) || 0;
      this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;
    }
  }

  cijenaIzmijenjena(e){
    //console.log(e);
    if(e.value && e.event != undefined){
      //console.log('cijenaIzmijenjena: ', e);
      this.cijenaPopup = e.value;
      this.brutoPopup = +(this.kolicinaPopup*+this.cijenaPopup).toFixed(2) || 0;
      let rabatNetoC = +(this.cijenaPopup*(+this.rabatPopup/100)) || 0;
      this.netoCijena = (+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
      this.netoVrijednost = +(+this.netoCijena*+this.kolicinaPopup).toFixed(3) || 0;
      this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;
    }
  }

  onChangeBV(e){
    //console.log(e);
    if(e.value && e.event != undefined){
      //console.log('onChangeBV: ', e);
      this.brutoPopup=e.value;
      this.cijenaPopup = +(+this.brutoPopup/+this.kolicinaPopup).toFixed(5) || 0;
      let rabatNetoC = +(this.cijenaPopup*(+this.rabatPopup/100)) || 0;
      this.netoCijena = (+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
      this.netoVrijednost = +(+this.netoCijena*+this.kolicinaPopup).toFixed(3) || 0;
      this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;
    }
  }

  onValuChangedRabat(e){
    //console.log(e);
    if(e.value && e.event != undefined){
      //console.log('onValuChangedRabat: ', e);
      this.rabatPopup = e.value;
      let rabatNetoC = +(+this.cijenaPopup*(+this.rabatPopup/100)) || 0;
      this.netoCijena = (+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
      this.netoVrijednost = (+this.netoCijena*+this.kolicinaPopup).toFixed(3) || 0;
      this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;
    }
    if(e.value == ""){
      this.rabatPopup = 0;
      let rabatNetoC = +(+this.cijenaPopup*(+this.rabatPopup/100)) || 0;
      this.netoCijena = (+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
      this.netoVrijednost = (+this.netoCijena*+this.kolicinaPopup).toFixed(3) || 0;
      this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;
    }
  }

  onChangeNV(e){
    if(e.value && e.event != undefined){
      //console.log('uso u onChangeNV: ', e);
      this.netoVrijednost = e.value;
      this.rabatPopup = +(((+this.brutoPopup-+this.netoVrijednost)/this.brutoPopup)*100).toFixed(4);
      let rabatNetoC = +(this.cijenaPopup*(+this.rabatPopup/100)).toFixed(2) || 0;
      this.netoCijena = (+this.cijenaPopup - +rabatNetoC).toFixed(3) || 0;
    }
  }

  onValuChangedNC(e){
    if(e.value && e.event != undefined){
      //console.log('onValuChangedNC: ', e);
      this.netoCijena = e.value;
      this.netoVrijednost = (+this.netoCijena* +this.kolicinaPopup).toFixed(3) || 0;
      this.rabatPopup = +(((+this.brutoPopup- +this.netoVrijednost)/+this.brutoPopup)*100).toFixed(5);
      this.rabat_iznosPopup = (this.brutoPopup - this.netoVrijednost).toFixed(2) || 0;
    }
  }

  dodajStavku(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      pz_id: this.odabranoZaglavlje_id,
      ar_id: this.idArtikl,
      kolicina: e.ps_ulaz,
      nabcij: e.ps_nabcij,
      brutovrij: e.ps_bruto_vrijednost,
      rabat: e.ps_postorabata,
      netocij: e.neto_cijena,
      netovrij: e.neto_vrijednost,
      vrijedido: moment(e.ps_vazido).format('YYYY-MM-DD'),
    };
    //console.log(podaciZaSlanje);
    this.service.primka_stavka_dodaj(podaciZaSlanje).subscribe((res) => {
      if (res.success === true) {
        this.dohvatiStavke();
        this.dodajStavkuPopup = false;
        this.podaci_stavka = [];
        this.odabranArtikl = '';
        notify('Uspješno dodana stavka.', 'success', 3000);
      } else {
        notify(res, 'warning', 3000);
      }
    });
  }

  urediStavku(e:any) {
    //console.log(e);
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      pz_id: this.odabranoZaglavlje_id,
      ps_id: this.psId,
      ar_id: this.idArtikl,
      kolicina: e.ps_ulaz,
      nabcij: e.ps_nabcij,
      brutovrij: e.ps_bruto_vrijednost,
      rabat: e.ps_postorabata,
      netocij: e.neto_cijena,
      netovrij: e.neto_vrijednost,
      vrijedido: moment(e.ps_vazido).format('YYYY-MM-DD'),
   };
   //console.log(podaciZaSlanje);
   this.service.primka_stavka_uredi(podaciZaSlanje).subscribe((res) => {
     if (res.success == true) {
       this.dohvatiStavke();
       this.dodajStavkuPopup = false;
       this.podaci_stavka = [];
       notify('Uspješno spremljeni podaci.', 'success', 3000);
     } else {
       notify(res.message, 'warning', 3000);
     }
   });
 }

  stavkaDetalji(e: any){
    //console.log(e);
    //console.log(e.data);
    this.naslov = "Uredi stavku";
    this.podaci_stavka = e.data;
    this.btn_uredi_stavka = 1;
    this.psId = e.data.ps_id;
    this.dodajStavkuPopup = true;
    this.idArtikl = e.data.artikl_ar_id;
    this.odabranArtikl = e.data.sifrainaziv;
    //this.podaci_stavka.za_nabcij = e.data.za_nabcij;
    //this.podaci_stavka.za_stanje = e.data.za_stanje;
    this.kolicinaPopup = e.data.ps_ulaz;
    //this.podaci_stavka.ps_nabcij = e.data.ps_nabcij;
    this.cijenaPopup = e.data.ps_nabcij;
    this.brutoPopup = e.data.ps_bruto_vrijednost;
    //this.podaci_stavka.ps_vazido = e.data.ps_vazido;
    //this.podaci_stavka.ps_postorabata = e.data.ps_postorabata;
    this.rabatPopup = e.data.ps_postorabata;
    //this.podaci_stavka.ps_rabat = e.data.ps_rabat;
    //this.podaci_stavka.neto_cijena = e.data.ps_ulazc;
    this.netoCijena = e.data.ps_ulazc;
    //this.podaci_stavka.neto_vrijednost = e.data.ps_ulazvr;
    this.netoVrijednost = e.data.ps_ulazvr;

  }

  obrisiStavku(e){
    //console.log(e);
    let myDialog = custom({
      title: "Brisanje",
      messageHtml: "Jeste li sigurni da želite obrisati stavku?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this.service.primka_stavka_obrisi({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'ps_id': e.data.ps_id
        }).subscribe(res=>{
          if(res.success == true){
            this.dohvatiStavke();
            notify('Uspješno ste obrisali stavku.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      }else{  }
    });
  }

  odustaniStavka(){
    this.dodajStavkuPopup = false;
    //this.idstavka = null;
    this.podaci_stavka = [];
  }

  pdfIzdatnicaLotSirovinaPojedinacno(data) {
    console.log(data);
    this.pdfZaIzdatniceLotSirovinaPojedinacnoService.pdfZaIzdatniceLotSirovinPojedinacnoService(data.data);
  }

  onRowClick(e) {
    if (e.rowType === 'data' && e.handled !== true) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onRowUpdated(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: e.data.pz_id
    };
    //console.log(podaciZaSlanje);
  }

  onValueChangedDatumOd(e: any) {
    if (this.isProcessing) return;
    
    //console.log('onValueChanged Datum OD:', e);
    
    if (e.value instanceof Date) {
      this.datumOd = e.value;
      this.datumOd_za_slanje = moment(e.value).format('YYYY-MM-DD');
    }
  }

  onInputDatumOd(e: any) {
    if (this.isProcessing) return;
    
    const inputElement = e.event?.target;
    if (!inputElement) return;
    
    const inputValue = inputElement.value;
    //console.log('onInput Datum DO:', inputValue);
    
    // Provjeri da li je unos u formatu dd.MM ili dd.MM.
    if (this.isPartialDateFormat(inputValue)) {
      // Ne radi ništa ovdje, čekaj onFocusOut
      return;
    }
  }

  onFocusOutDatumOd(e: any) {
    if (this.isProcessing) return;
    
    const component = e.component;
    const inputValue = component.option('text') || '';
    
    //console.log('onFocusOut Datum OD:', inputValue);
    
    if (this.isPartialDateFormat(inputValue)) {
      this.processPartialDateOd(inputValue, component);
    }
  }

  private isPartialDateFormat(value: string): boolean {
    // Provjeri format: dd.MM ili dd.MM. ili dd,MM ili dd,MM,
    return /^\d{1,2}[.,]\d{1,2}[.,]?$/.test(value.trim());
  }

  private processPartialDateOd(inputValue: string, component: any) {
    this.isProcessing = true;
    
    try {
      // Ukloni završnu točku ili zarez i normaliziraj separatore
      const cleanValue = inputValue.trim().replace(/[.,]$/, '');
      const parts = cleanValue.split(/[.,]/); // Split po točki ili zarez
      
      if (parts.length >= 2) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const currentYear = new Date().getFullYear();
        
        // Validacija osnovnih vrijednosti
        if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
          const newDate = new Date(currentYear, month - 1, day);
          
          if (newDate.getMonth() === month - 1 && newDate.getDate() === day) {
            //console.log('Setting parsed date:', newDate);
            
            // Postavi novu vrijednost
            component.option('value', newDate);
            this.datumOd = newDate;
            this.datumOd_za_slanje = moment(newDate).format('YYYY-MM-DD');
            
            // Očisti bilo kakve greške validacije
            setTimeout(() => {
              component.option('isValid', true);
            }, 50);
          } else {
            this.handleInvalidDateOd(component, inputValue);
          }
        } else {
          this.handleInvalidDateOd(component, inputValue);
        }
      }
    } catch (error) {
      //console.error('Error processing partial date:', error);
      this.handleInvalidDateOd(component, inputValue);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 100);
    }
  }

  private handleInvalidDateOd(component: any, inputValue: string) {
    //console.log('Invalid date format for Datum OD:', inputValue);
    // Očisti nevaljan unos
    //component.option('value', null);
    //component.option('text', '');
    this.datumOd = null;
    this.datumOd_za_slanje = null;
  }

  // Glavna funkcija za rukovanje ENTER tipkom - Datum OD
  onKeyDownDatumOd(e: any) {
    // Kad korisnik pritisne Enter
    if (e.event.key === 'Enter') {
      const component = e.component;
      const inputValue = component.option('text') || '';
      
      //console.log('Enter pressed on Datum OD, input value:', inputValue);
      
      if (this.isPartialDateFormat(inputValue)) {
        e.event.preventDefault(); // Sprječava default ponašanje
        
        // Procesiranje datuma
        this.processPartialDateOd(inputValue, component);
        
        // Prebaci fokus na "Datum do" nakon kratke pauze
        setTimeout(() => {
          this.focusOnDatumDo();
        }, 150);
      } else {
        // Ako je datum već valjan, samo prebaci fokus
        e.event.preventDefault();
        this.focusOnDatumDo();
      }
    }
    // ESC za otkazivanje
    else if (e.event.key === 'Escape') {
      const component = e.component;
      component.option('value', this.datumOd); // Vrati prethodnu vrijednost
      e.event.target.blur();
    }
  }

  // Funkcija za rukovanje ENTER tipkom - Datum DO
  onKeyDownDatumDo(e: any) {
    // Kad korisnik pritisne Enter
    if (e.event.key === 'Enter') {
      const component = e.component;
      const inputValue = component.option('text') || '';
      
      //console.log('Enter pressed on Datum DO, input value:', inputValue);
      
      if (this.isPartialDateFormat(inputValue)) {
        e.event.preventDefault(); // Sprječava default ponašanje

        // Prvo procesiranje datuma
        this.processPartialDateDo(inputValue, component);
          
        // Zatim simulacija klika na "Pretraži" nakon kratke pauze
        setTimeout(() => {
          document.getElementById('pretrazi')?.focus();
          this.simulateSearchClick();
        }, 200);
      } else {
        // Ako je datum već valjan, direktno simuliraj klik na "Pretraži"
        e.event.preventDefault();
        document.getElementById('pretrazi')?.focus();
        this.simulateSearchClick();
      }
    }
    // ESC za otkazivanje
    else if (e.event.key === 'Escape') {
      const component = e.component;
      component.option('value', this.datumDo);
      e.event.target.blur();
    }
  }

  // Funkcija za simulaciju klika na gumb "Pretraži"
  private simulateSearchClick() {
    //console.log('Simulating search button click...');
    
    // Metoda 1: Korištenje ViewChild reference
    // if (this.pretraziRef) {
    //   try {
    //     // DevExtreme Button API
    //     this.pretraziRef.instance.option('onClick')();
    //     return;
    //   } catch (error) {
    //     //console.log('ViewChild method failed, trying alternative approaches');
    //   }
    // }
    
    // Metoda 2: Direktno pozivanje funkcije pretrage
    this.pretrazi();
    
    // Metoda 3: DOM pristup (backup)
    // setTimeout(() => {
    //   const searchButton = document.querySelector('dx-button[text="Pretraži"]') ||
    //       document.querySelector('button[title="Pretraži"]') ||
    //       document.querySelector('button:contains("Pretraži")') ||
    //       document.querySelector('.dx-button:contains("Pretraži")');
      
    //   if (searchButton) {
    //     (searchButton as HTMLElement).click();
    //   }
    // }, 50);
  }

  // Funkcija za prebacivanje fokusa na "Datum do"
  private focusOnDatumDo() {
    if (this.datumDoRef) {
      try {
        // Pokušaj sa DevExtreme API
        this.datumDoRef.instance.focus();
      } catch (error) {
        //console.log('DevExtreme focus failed, trying DOM approach');
        // Backup - direktno DOM pristup
        const datumDoElement = document.querySelector('dx-date-box[#datumDoRef] input') || 
              document.querySelector('.dx-texteditor-input[data-dx_placeholder*="do"]') ||
              document.querySelectorAll('.dx-texteditor-input')[1]; // Drugi DateBox
          
        if (datumDoElement) {
          (datumDoElement as HTMLElement).focus();
        }
      }
    }
  }

  onValueChangedDatumDo(e: any) {
    if (this.isProcessing) return;
    
    //console.log('onValueChanged Datum DO:', e);
    
    if (e.value instanceof Date) {
      this.datumDo = e.value;
      this.datumDo_za_slanje = moment(e.value).format('YYYY-MM-DD');
    }
  }

  onInputDatumDo(e: any) {
    if (this.isProcessing) return;
    
    const inputElement = e.event?.target;
    if (!inputElement) return;
    
    const inputValue = inputElement.value;
    //console.log('onInput Datum DO:', inputValue);

    // Provjeri da li je unos u formatu dd.MM ili dd.MM.
    if (this.isPartialDateFormat(inputValue)) {
      // Ne radi ništa ovdje, čekaj onFocusOut
      return;
    }
  }

  onFocusOutDatumDo(e: any) {
    if (this.isProcessing) return;
    
    const component = e.component;
    const inputValue = component.option('text') || '';
    
    //console.log('onFocusOut Datum DO:', inputValue);
    
    if (this.isPartialDateFormat(inputValue)) {
      this.processPartialDateDo(inputValue, component);
    }
  }

  // Procesiranje datuma za "Datum do"
  private processPartialDateDo(inputValue: string, component: any) {
    this.isProcessing = true;
    
    try {
      const cleanValue = inputValue.trim().replace(/[.,]$/, '');
      const parts = cleanValue.split(/[.,]/);
      
      if (parts.length >= 2) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const currentYear = new Date().getFullYear();
        
        if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
          const newDate = new Date(currentYear, month - 1, day);
            
          if (newDate.getMonth() === month - 1 && newDate.getDate() === day) {
            //console.log('Setting parsed date for Datum DO:', newDate);
            
            component.option('value', newDate);
            this.datumDo = newDate;
            this.datumDo_za_slanje = moment(newDate).format('YYYY-MM-DD');
              
            setTimeout(() => {
              component.option('isValid', true);
            }, 50);
          } else {
            this.handleInvalidDateDo(component, inputValue);
          }
        } else {
          this.handleInvalidDateDo(component, inputValue);
        }
      }
    } catch (error) {
      //console.error('Error processing partial date for Datum DO:', error);
      this.handleInvalidDateDo(component, inputValue);
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 100);
    }
  }

  private handleInvalidDateDo(component: any, inputValue: string) {
    //console.log('Invalid date format for Datum DO:', inputValue);
    // Očisti nevaljan unos
    //component.option('value', null);
    //component.option('text', '');
    this.datumDo = null;
    this.datumOd_za_slanje = null;
  }

  pretrazi(){
    this.dohvatiPrimke();
  }

  dohvatiPrimke(){
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datumod: this.datumOd_za_slanje, 
      datumdo: this.datumDo_za_slanje,
      dv_sifra: 'PRISKL'
    }
    //console.log(podaciZaSlanje);
    this.primke = [];
    this.service.prometzagPopis(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.disableGumb = false;
      if (res.success == true) {
        this.primke = res.data;
      }
      
      if (this.primke.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  povezaniDokumenti(data) {
    //console.log(data);
    this.naslov = 'Popis povezanih dokumenata';
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: data.data.pz_id,
      dv_id: data.data.dokumentvrsta_dv_id
    }
    //console.log(podaciZaSlanje);
    this.povezani_dokumenti = [];
    this.service.povezani_dokumenti_popis(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.povezaniDokumentiPopup = true;
      if (res.success == true) {
        this.povezani_dokumenti = res.data;
      } else {

      }
    });
  }

  uredu(){
    this.povezaniDokumentiPopup = false;
  }

  primkaPDF(data) {
    //console.log(data);
    //console.log(data.data);
    this.pdfzaprimkeService.pdfPrimka(data);
  }

  dodajPrimku(){
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      dv_sifra: 'PRISKL',
      datum: moment(this.datum).format('YYYY-MM-DD'),
      godina: moment(this.datum).format('YYYY'),
      po_id: this.odabranoSkladiste_id,
      pa_id: this.odabraniPartner_id,
      pp_id: this.odabranaPoslovnicaPartnera_id,
      pz_dokumpar: this.brojOtpremnice,
      napomena: this.napomena
    }
    //console.log(podaciZaSlanje);
    this.service.primka_dodaj(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.dohvatiPrimke();
      this.dodaj_urediPrimkuPopupVisible = false;
      if (res.success == true) {
        notify('Uspješno dodana nova primka.', 'success', 3000);
      }else {
        notify(res.message, 'error', 3000);
      }
    });
  }

  urediPrimku(){
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      dv_sifra: 'PRISKL',
      pz_id: this.pzId,
      datum: moment(this.datum).format('YYYY-MM-DD'),
      po_id: this.odabranoSkladiste_id,
      pa_id: this.odabraniPartner_id,
      pp_id: this.odabranaPoslovnicaPartnera_id,
      pz_dokumpar: this.brojOtpremnice,
      napomena: this.napomena
    }
    //console.log(podaciZaSlanje);
    this.service.primka_uredi(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.dohvatiPrimke();
      this.dodaj_urediPrimkuPopupVisible = false;
      if (res.success == true) {
        notify('Uspješno uređena primka.', 'success', 3000);
      }else {
        notify(res.message, 'error', 3000);
      }
    });
  }

  stornirajPrimku(e){
    //console.log(e);
    let myDialog = custom({
      title: "Storniranje",
      messageHtml: "Jeste li sigurni da želite stornirati primku?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this.service.primka_storno({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'pz_id': e.data.pz_id,
          'pz_broj': e.data.pz_broj
        }).subscribe(res=>{
          if(res.success == true){
            this.dohvatiPrimke();
            this.odabranoZaglavlje_status = 'S';
            this.dozvoliUredivanje = false;
            this.dohvatiStavke();
            notify('Uspješno ste stornirali primku.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      }else{  }
    });
  }

  zavrsiPrimku(e){
    //console.log(e);
    let myDialog = custom({
      title: "Završavanje",
      messageHtml: "Jeste li sigurni da želite završiti primku?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this.loadingVisible = true;
        this.service.primka_zavrsi({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'pz_id': e.data.pz_id
        }).subscribe(res=>{
          this.loadingVisible = false;
          if(res.success == true){
            this.dohvatiPrimke();
            this.odabranoZaglavlje_status = 'Z';
            this.dozvoliUredivanje = false;
            this.dohvatiStavke();
            notify('Uspješno ste završili primku.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      }else{  }
    });
  }

  obrisiPrimku(e){
    //console.log(e);
    let myDialog = custom({
      title: "Brisanje",
      messageHtml: "Jeste li sigurni da želite obrisati primku?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this.service.primka_obrisi({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'pz_id': e.data.pz_id
        }).subscribe(res=>{
          if(res.success == true){
            this.dohvatiPrimke();
            notify('Uspješno ste obrisali primku.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      }else{  }
    });
  }

  urediZavrsene(p) {
    if(p == 1) {
      this.urediZavrsenePrimke = !this.urediZavrsenePrimke;
      console.log(this.urediZavrsenePrimke)
    }
  }

  ngOnInit(): void {
  }

}
